import React, { Component } from 'react'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'

configureAnchors({offset: -100, scrollDuration: 200})

export default class ScrollAnchor extends Component {
  render() {
    const { moduleId } = this.props

    return (
      <ScrollableAnchor id={ moduleId }>
        <div />
      </ScrollableAnchor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ScrollAnchor/index.js